import { AutogenLayoutOrderPlanningActions } from "./autogen/AutogenLayoutOrderPlanningActions";
import { OrderPlanningToolPanel, ToolConstructor } from "./OrderPlanningToolPanel";
import { Layout, Overlay } from "@mcleod/components";
import { Alignment, HorizontalAlignment } from "@mcleod/core";

export class OrderPlanningActions extends AutogenLayoutOrderPlanningActions {
    private layoutToolPanel: OrderPlanningToolPanel;
    private _overlay: Overlay;

    async onLoad() {
        this.buttonActions.setProps({align: HorizontalAlignment.LEFT});
        this.buttonActions.imageProps = {marginTop: -4};
        this.layoutToolPanel = await Layout.getLoadedLayout("lme/dispatch/planning/OrderPlanningToolPanel") as OrderPlanningToolPanel;
    }

    async showButtons(...tools: ToolConstructor[]) {
        this.layoutToolPanel.showButtons(this, ...tools);
    }

    panelActionsButtonOnClick () {
        if (!this.layoutToolPanel.prepareForOverlay()) return;
        this._overlay = Overlay.showInOverlay(this.layoutToolPanel, {
            anchor: {
                anchor: this.buttonActions,
                align: Alignment.CENTER,
                position: Alignment.BOTTOM,
            },
        });
    }

    get toolPanel() {
        return this.layoutToolPanel;
    }

    get overlay(): Overlay {
        return this._overlay;
    }
}
